// src/pages/Register.jsx
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import API from '../api';
import { useNavigate, Link } from 'react-router-dom';
import { loginSuccess } from '../store/authSlice';
import './css/login.css';

function Register() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    username: '',
    email: '',
    mobile: '',
    role: '',
    password: '',
    confirmPassword: '',
  });

  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const onChange = (e) => {
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));
    if (error) setError('');
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!form.username || !form.email || !form.mobile || !form.role || !form.password) {
      setError('All fields are required.');
      return;
    }
    if (form.password.length < 6) {
      setError('Password must be at least 6 characters.');
      return;
    }
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    try {
      setLoading(true);

      // Server sets HttpOnly cookie and returns { user }
      const { data } = await API.post('/auth/register', {
        username: form.username.trim(),
        email: form.email.trim().toLowerCase(),
        mobile: form.mobile.trim(),
        role: form.role,
        password: form.password,
      });

      const user = data?.user;
      if (!user) throw new Error('Unexpected response from server.');

      dispatch(loginSuccess({ user }));
      navigate('/', { replace: true });
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        'Registration failed.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mm-login-container">
      <div className="mm-login-left">
        <div className="mm-welcome-message">
          <h1>Create your account</h1>
          <p>Welcome! Please fill in the details to continue.</p>
        </div>
      </div>

      <div className="mm-login-right">
        <form onSubmit={onSubmit} className="mm-login-form" noValidate>
          <h2 className="mm-login-title">Register</h2>
          <p className="mm-login-subtitle">It only takes a minute.</p>

          {error && <div className="mm-error-message" role="alert">{error}</div>}

          <input
            className="mm-login-input"
            type="text"
            name="username"
            placeholder="Username"
            value={form.username}
            onChange={onChange}
            autoComplete="username"
            required
          />

          <input
            className="mm-login-input"
            type="email"
            name="email"
            placeholder="Email"
            value={form.email}
            onChange={onChange}
            autoComplete="email"
            required
          />

          <input
            className="mm-login-input"
            type="tel"
            name="mobile"
            placeholder="Mobile Number"
            value={form.mobile}
            onChange={onChange}
            autoComplete="tel"
            required
          />

          <select
            className="mm-login-input"
            name="role"
            value={form.role}
            onChange={onChange}
            required
          >
            <option value="" disabled>Role</option>
            <option value="admin">Admin</option>
            <option value="sub-admin">Sub-Admin</option>
            <option value="agent">Agent</option>
          </select>

          <input
            className="mm-login-input"
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={onChange}
            autoComplete="new-password"
            required
          />

          <input
            className="mm-login-input"
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            value={form.confirmPassword}
            onChange={onChange}
            autoComplete="new-password"
            required
          />

          <button className="mm-login-button" type="submit" disabled={loading}>
            {loading ? 'Creating account…' : 'Register'}
          </button>

          <p className="mm-login-footer" style={{ marginTop: 16 }}>
            Already have an account? <Link to="/login">Log in</Link>
          </p>
        </form>
      </div>
    </section>
  );
}

export default Register;
